
// 認証情報 cookie 利用フラグ
export const COOKIE = Object.freeze(
  {
    FALSE: 0, // 利用しない
    TRUE: 1 // 利用する
  }
)

export const MESSAGE_TITLE = 'CCS'

// 詳細画面モード(共通)
export const MODE = Object.freeze(
  {
    NORMAL: 0, // 通常
    EDIT: 1, // 修正
    NEW: 2, // 新規
    DELETE: 9 // 削除
  }
)

// 注文詳細画面モード
export const ORDER_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: 1, // 注文修正
    SHORTAGE: 2, // 再送
    RECEIVED: 3, // 返品登録
    EXCHANGE: 4, // 交換出荷
    EXPORT: 5, // 指図登録
    SHIPMENT: 6, // 配送先登録
    CAPTURE: 7, // 手動決済
    CHANGE_PAYMENT: 8, // 支払方法変更
    CANCEL: 9 // 注文取消
  }
)

// 出荷指図種類
export const ORDER_EXPORT_TYPE = Object.freeze(
  {
    NORMAL: 1, // 通常
    SHORTAGE: 2, // 再送
    EXCHANGE: 3 // 交換出荷
  }
)

// 決済連携 API メソッド
export const PAYMENT_METHOD = Object.freeze(
  {
    0: null,
    1: 'reauth',
    2: 'capture',
    3: 'refund',
    4: 'cancel'
  }
)

// アカウント詳細画面モード
export const ACCOUNT_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT, // 編集
    NEW: MODE.NEW, // 新規
    DELETE: 8 // 削除
  }
)

// サイトロール・権限ロール詳細画面モード
export const ROLE_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT, // 編集
    NEW: MODE.NEW, // 新規
    DELETE: 9 // 削除
  }
)

// 在庫アラート詳細画面モード
export const STOCK_ALERT_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT, // 編集
    NEW: MODE.NEW, // 新規
    DELETE: 9 // 削除
  }
)

// カラーマスタ画面モード
export const PRODUCT_COLOR_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

// カラーグループマスタ画面モード
export const PRODUCT_COLORGROUP_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

// サイズマスタ画面モード
export const PRODUCT_SIZE_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

// サイズグループマスタ画面モード
export const PRODUCT_SIZEGROUP_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

// 構成品マスタ画面モード
export const PRODUCT_COMPONENT_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

// 配送休業日マスタ画面モード
export const LOGISTICS_CALENDAR_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT // 編集
  }
)

/**
 * 価格区分
 */
export const SALE_TYPE = Object.freeze(
  {
    REGULAR_PRICE: 0, // 定価
    PROPER: 1, // プロパー
    SALE: 2 // セール
  }
)

/**
 * 税率区分
 */
export const TAX_RATE_TYPE = Object.freeze(
  {
    NORMAL: 0, // 通常税率
    REDUCED: 1, // 軽減税率
    FREE: 2 // 非課税
  }
)

/**
 * ギフトタイプ
 */
export const GIFT_TYPE = Object.freeze(
  {
    NONE: 0,        // なし
    SUMMARY: 1,     // まとめ包装
    INDIVIDUALLY: 2 // 個別包装
  }
)

/**
 * 支払方法区分
 */
export const PAYMENT_METHOD_TYPE = Object.freeze(
  {
    NO_PROCESS: 1,      // 支払処理不要
    CCS: 2,             // CCS決済
    SITE: 3,            // サイト決済
    CCS_NO_REFUND: 4,   // CCS決済 返金連携なし
    SITE_NO_REFUND: 5,  // サイト決済済み、返金連携なし
    CCS_NO_REFUND_NO_COMP: 6,   // CCS決済 返金連携なし
    SITE_NO_REFUND_NO_COMP: 7,  // サイト決済済み、返金連携なし
    HOLD: 99            // 保留
  }
)

/**
 * 支払処理処理コード
 */
export const PAYMENT_SET_PROCESS = Object.freeze(
  {
    AUTH: 1,              // 与信
    RE_AUTH: 2,           // 再与信
    CAPTURE: 3,           // 決済
    REFUND: 4,            // 返金
    CANCEL: 9,            // 取消
    CAPTURE_CHEKKNG: 10,  // 決済確認
    REFUND_CHEKING: 11,   // 返金確認
    FAILURE_CANCEL: 12,   // 障害取消
    DUMMY: 88             // ダミー
  }
)

/**
 * 支払処理ステータス
 */
export const PAYMENT_SET_STATUS = Object.freeze(
  {
    UNPROCESSED: 0,       // 処理待ち
    PROCESSING: 1,        // 処理中
    PROCESSED: 2,         // 処理済み
    CHECKING: 3,          // 確認中
    CANCELED: 7,          // キャンセル済み
    VOID: 8,              // 無効なステータス
    ERROR_END: 9,         // エラー終了
    MANUALCOMPLETION: 21, // 手動完了
    ERROR_RETRIED: 91,    // エラー再実行済み
    ERRO_RPROCESSED: 92   // エラー処理済み
  }
)

/**
 *
 */
export const PRODUCT_CATEGORY = Object.freeze(
  {
    NORMAL: 'normal',     // 通常商品
    BUNDLE: 'bundle',     // バンドル
    SET: 'set'            // セット
    // OPTION: 3,            // オプション
  }
)
/**
 * EC在庫アラート設定有効フラグ
 */
export const STOCK_ALERT_STATUS = Object.freeze(
  {
    ENABLE: 1,       // 有効
    DISABLE: 0       // 無効
  }
)

/**
 * 商品カスタマイズ属性対象タブ
 */
export const CUSTOMIZE_PROPERTY_KEY = Object.freeze(
  {
    PRODUCT: {
      // 基本情報タブ
      BASIC_INFO: {
        // 共通カスタマイズ項目
        COMMON: {
          LEFT: 'product_basic_info_left',
          RIGHT: 'product_basic_info_right'
        },
        // 種類に紐づくカスタマイズ項目
        PRODUCT_TYPE: {
          LEFT: 'product_basic_info_{productType}_left',
          RIGHT: 'product_basic_info_{productType}_right'
        }
      },
      // 商品説明タブ
      INTRODUCTION: {
        // 共通カスタマイズ項目
        COMMON: {
          LEFT: 'product_introduction_left',
          RIGHT: 'product_introduction_right'
        }
      },
      // SKUタブ
      SKU: {
        // 共通カスタマイズ項目
        COMMON: {
          LEFT: 'product_sku_left',
          RIGHT: 'product_sku_right'
        },
        // 商品種類に紐づくカスタマイズ項目
        PRODUCT_TYPE: {
          LEFT: 'product_sku_{productType}_left',
          RIGHT: 'product_sku_{productType}_right'
        },
        // SKU種類に紐づくカスタマイズ項目
        SKU_TYPE: {
          LEFT: 'product_sku_{skuType}_left',
          RIGHT: 'product_sku_{skuType}_right'
        }
      },
      // バンドルタブ
      BUNDLE: {
        // 共通カスタマイズ項目
        COMMON: {
          LEFT: 'product_bundle_left',
          RIGHT: 'product_bundle_right'
        },
        // 商品種類に紐づくカスタマイズ項目
        PRODUCT_TYPE: {
          LEFT: 'product_bundle_{productType}_left',
          RIGHT: 'product_bundle_{productType}_right'
        },
        // SKU種類に紐づくカスタマイズ項目
        SKU_TYPE: {
          LEFT: 'product_bundle_{skuType}_left',
          RIGHT: 'product_bundle_{skuType}_right'
        },
        COMPONENT: 'product_bundle_component'
      },
      // 画像タブ
      IMAGE: 'product_image',
      // 商品検索内表示項目
      PRODUCT_SEARCHER: 'product_searcher',
      // 商品検索内データ詳細表示項目
      PRODUCT_SEARCHER_DETAIL: 'product_searcher_detail'
    }
  }
)
/**
 * 対象在庫種別
 */
export const STOCK_TYPE = Object.freeze(
  {
    NORMAL: 1,       // 通常
    RESERVED: 1,       // 予約
    TAKING: 3       // 取寄
  }
)

/**
 * メールタイプ
 */
export const MAIL_TYPE = Object.freeze(
  {
    CANCEL: 'canceled'  // キャンセルメール
  }
)

// メールテンプレート詳細画面モード
export const MAIL_TEMPLATE_MODE = Object.freeze(
  {
    NORMAL: MODE.NORMAL, // 通常
    EDIT: MODE.EDIT, // 編集
    NEW: MODE.NEW, // 新規
    CONFIRM: 3, // 確認
    DELETE: 9 // 削除
  }
)

// 顧客詳細画面モード
export const CUSTOMER_MODE = Object.freeze(
  {
    CUSTOMER_EDIT: 1, // 顧客編集
    POINT_NEW: 2 // ポイント登録
  }
)

/**
 * 二段階認証ステータス
 */
export const AUTH_MFA_STATUS = Object.freeze(
  {
    INVALID: 0,         // MFA認証無効
    UNREGISTERED: 1,    // 未登録
    UNAUTHENTICATED: 2, // 未認証（MFA認証有効）
    AUTHENTICATED: 3    // 認証済（MFA認証有効）
  }
)

/**
 * 権限項目キー
 */
export const PermissionKeys = Object.freeze({
  DASHBOARD: 'menu_dashboard', // ツリーとして使用。権限としては用いない
  Dashboard: {
    CUSTOMER_ALERT: 'dashboard_customer_alert',
    CustomerAlert: {
      CATEGORY: 'dashboard_customer_alert_category',
      DATETIME: 'dashboard_customer_alert_datetime'
    },
    INFORMATION: 'dashboard_information',
    Information: {
      CATEGORY: 'dashboard_information_category',
      DATETIME: 'dashboard_information_datetime'
    }
  },
  ORDER: 'menu_order',
  Order: {
    // 注文一覧
    LIST: 'order_list',
    List: {
      SHIPMENT_ID: 'order_list_shipment_id',
      ORDERER_NAME: 'order_list_orderer_name',
      ORDERER_NAME_KANA: 'order_list_orderer_name_kana',
      PURCHASE_AMOUNT: 'order_list_purchase_amount',
      SITE: 'order_list_site',
      ORDER_DATETIME: 'order_list_order_datetime',
      IS_PAID: 'order_list_is_paid',
      PAYMENT_METHOD: 'order_list_payment_method',
      ORDER_STATUS: 'order_list_order_status',
      ORDER_NOTES: 'order_list_order_notes',
      LEAD_TIME: 'order_list_lead_time',
      POSTAL_CODE: 'order_list_recipient_postal_code',
      STATE: 'order_list_recipient_state',
      CITY: 'order_list_recipient_city',
      ADDRESS_1: 'order_list_recipient_address1',
      ADDRESS_2: 'order_list_recipient_address2',
      PRODUCT_NAME: 'order_list_product_name',
      PRODUCT_QTY: 'order_list_product_qty',
      RED_RESULT: 'order_list_red_result',
      MAIL: 'order_select_target_for_mail',
      MAX_GET_COUNT: 'order_list_max_get_count'
    },

    // 臨時出荷依頼一覧
    EXTRA_EXPORT_LIST: 'extra_export_order_request_list',
    ExtraExportRequestList: {
      EXPORT_REQUEST: 'extra_export_order_request'
    },

    // 注文詳細
    DETAIL: 'order_detail',
    Detail: {
      // 操作
      EDIT: 'order_detail_edit',
      SHORTAGE: 'order_detail_shortage',
      RECEIVED: 'order_detail_received',
      EXCHANGE: 'order_detail_exchange',
      SHIPMENT: 'order_detail_shipment',
      CAPTURE: 'order_detail_capture',
      CANCEL: 'order_detail_cancel',
      OPLUX: 'order_detail_oplux_event_edit',

      // 項目
      // 注文情報
      ORDER_INFO: 'order_detail_order_info',
      OrderInfo: {
        // 基本情報
        BASIC_INFO: 'order_detail_order_info_basic_info',
        BasicInfo: {
          ATTRIBUTE: 'order_detail_order_info_basic_info_attribute',
          Attribute: {
            // 操作
            ATTRIBUTE_EDIT: 'order_detail_order_info_basic_info_attribute_edit'
          },
          SITE: 'order_detail_order_info_basic_info_site',
          ORDER_DATETIME: 'order_detail_order_info_basic_info_order_datetime',
          ORDER_TYPE: 'order_detail_order_info_basic_info_order_type',
          PAYMENT_METHOD: 'order_detail_order_info_basic_info_payment_method',
          ORDER_STATUS: 'order_detail_order_info_basic_info_order_status',
          IS_PAID: 'order_detail_order_info_basic_info_is_paid',
          RED_RESULT: 'order_detail_order_info_basic_info_red_result',
          CONSUMED_POINT: 'order_detail_order_info_basic_info_consumed_point'
        },

        // 注文者情報
        ORDERER_INFO: 'order_detail_order_info_orderer_info',
        OrdererInfo: {
          NAME: 'order_detail_order_info_orderer_info_name',
          NAME_KANA: 'order_detail_order_info_orderer_info_name_kana',
          TEL: 'order_detail_order_info_orderer_info_tel',
          POSTAL_CODE: 'order_detail_order_info_orderer_info_postal_code',
          COUNTRY: 'order_detail_order_info_orderer_info_country',
          STATE: 'order_detail_order_info_orderer_info_state',
          CITY: 'order_detail_order_info_orderer_info_city',
          ADDRESS_1: 'order_detail_order_info_orderer_info_address1',
          ADDRESS_2: 'order_detail_order_info_orderer_info_address2',
          SUITE: 'order_detail_order_info_orderer_info_suite',
          EMAIL: 'order_detail_order_info_orderer_info_email',
          POSTBOX: 'order_detail_order_info_orderer_info_postbox',
          CUSTOMER_NUMBER: 'order_detail_order_info_orderer_info_customer_number'
        },

        // 配送先情報
        SHIPMENT_INFO: 'order_detail_order_info_shipment_info',
        ShipmentInfo: {
          ATTRIBUTE: 'order_detail_order_info_shipment_info_attribute',
          Attribute: {
            // 操作
            ATTRIBUTE_EDIT: 'order_detail_order_info_shipment_info_attribute_edit'
          },
          NUMBER: 'order_detail_order_info_shipment_info_shipment_number',
          RECIPIENT_NAME: 'order_detail_order_info_shipment_info_recipient_name',
          RECIPIENT_NAME_KANA: 'order_detail_order_info_shipment_info_recipient_name_kana',
          RECIPIENT_TEL: 'order_detail_order_info_shipment_info_recipient_tel',
          RECIPIENT_POSTAL_CODE: 'order_detail_order_info_shipment_info_recipient_postal_code',
          RECIPIENT_COUNTRY: 'order_detail_order_info_shipment_info_recipient_country',
          RECIPIENT_STATE: 'order_detail_order_info_shipment_info_recipient_state',
          RECIPIENT_CITY: 'order_detail_order_info_shipment_info_recipient_city',
          RECIPIENT_ADDRESS_1: 'order_detail_order_info_shipment_info_recipient_address1',
          RECIPIENT_ADDRESS_2: 'order_detail_order_info_shipment_info_recipient_address2',
          RECIPIENT_SUITE: 'order_detail_order_info_shipment_info_recipient_suite',
          RECIPIENT_POSTBOX: 'order_detail_order_info_shipment_info_recipient_postbox',
          SHIPPING_METHOD: 'order_detail_order_info_shipment_info_shipping_method',
          GIFT_TYPE: 'order_detail_order_info_shipment_info_gift_type',
          GIFT_MESSAGE: 'order_detail_order_info_shipment_info_gift_message',
          DELIVERY_DATE: 'order_detail_order_info_shipment_info_delivery_date',
          DELIVERY_TIME: 'order_detail_order_info_shipment_info_delivery_time',
          SCHEDULED_SHIPPING_AT: 'order_detail_order_info_shipment_info_scheduled_shipping_at',
          EXPORTABLE_AT: 'order_detail_order_info_shipment_info_exportable_at',
          LEAD_TIME: 'order_detail_order_info_shipment_info_lead_time'
        },

        // 商品明細
        ITEM_DETAIL: 'order_detail_order_info_item_detail',
        ItemDetail: {
          // 操作
          GIFT: 'order_detail_order_info_item_detail_gift',
          SHIPPING: 'order_detail_order_info_item_detail_shipping',
          FEE: 'order_detail_order_info_item_detail_cod_fee',
          UNALLOCATED: 'order_detail_order_info_item_detail_unallocated',
          PRE_EXPORT: 'order_detail_order_info_item_detail_pre_export',
          CANCELED: 'order_detail_order_info_item_detail_canceled',
          TRANSFER: 'order_detail_order_info_item_detail_transfer',
          FORCE_SHIPMENT_CANCELED: 'order_detail_order_info_item_detail_force_shipment_canceled',
          FORCE_RECEIVE: 'order_detail_order_info_item_detail_force_receive',
          FORCE_RECEIVE_CANCEL: 'order_detail_order_info_item_detail_force_receive_cancel',
          ADD_ITEM_PRICE_ADJUSTMENT: 'order_detail_order_info_item_detail_add_item_price_adjustment',

          // 注文明細
          PRODUCT_DETAIL: 'order_detail_order_info_item_detail_product_detail',
          ProductDetail: {
            // 属性情報
            ATTRIBUTE: 'order_detail_order_info_item_detail_product_detail_attribute',
            Attribute: {
              // 操作
              ATTRIBUTE_EDIT: 'order_detail_order_info_item_detail_product_detail_attribute_attribute_edit'
            },
            BRAND: 'order_detail_order_info_item_detail_product_detail_brand',
            SKU: 'order_detail_order_info_item_detail_product_detail_sku',
            PRODUCT_SEARCHER: 'order_detail_order_info_item_detail_product_detail_product_searcher',
            PRODUCT_NAME: 'order_detail_order_info_item_detail_product_detail_product_name',
            COLOR: 'order_detail_order_info_item_detail_product_detail_color',
            SIZE: 'order_detail_order_info_item_detail_product_detail_size',
            IS_SALE: 'order_detail_order_info_item_detail_product_detail_is_sale',
            IS_GIFT: 'order_detail_order_info_item_detail_product_detail_is_gift',
            TAX_IN_BASE_PRICE: 'order_detail_order_info_item_detail_product_detail_tax_in_base_price',
            BASE_PRICE: 'order_detail_order_info_item_detail_product_detail_base_price',
            QUANTITY: 'order_detail_order_info_item_detail_product_detail_quantity',
            TAX: 'order_detail_order_info_item_detail_product_detail_tax',
            GROSS_PRICE: 'order_detail_order_info_item_detail_product_detail_gross_price',
            POINT: 'order_detail_order_info_item_detail_product_detail_point',
            CONSUMED_POINT: 'order_detail_order_info_item_detail_product_detail_consumed_point',
            PREPARING_SHIPMENT_STARTED_AT: 'order_detail_order_info_item_detail_product_detail_preparing_shipment_started_at',
            RELEASE_DATETIME: 'order_detail_order_info_item_detail_product_detail_release_datetime',
            IS_SHIPMENT: 'order_detail_order_info_item_detail_product_detail_is_shipment',

            // 数量明細
            QUANTITY_DETAIL: 'order_detail_order_info_item_detail_product_detail_quantity_detail',
            QuantityDetail: {
              ORDERED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ordered_qty',
              UNALLOCATED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_unallocated_qty',
              PENDING_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_pending_qty',
              PRE_EXPORT_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_pre_export_qty',
              PRE_RE_EXPORT_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_pre_re_export_qty',
              CANCELED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_canceled_qty',
              EXPORTED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_exported_qty',
              SHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_shipped_qty',
              UNSHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_unshipped_qty',
              INSHIP_CANCELED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_inship_canceled_qty',
              TRANSFER_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_transfer_qty',
              RECEIVE_SHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_receive_shipped_qty',
              RECEIVE_FIXED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_receive_fixed_qty',
              EX_OUT_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_out_qty',
              EX_OUT_EXPORTED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_out_exported_qty',
              EX_OUT_SHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_out_shipped_qty',
              EX_OUT_UNSHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_out_unshipped_qty',
              EX_OUT_FIXED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_out_fixed_qty',
              EX_IN_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_in_qty',
              EX_IN_SHIPPED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_in_shipped_qty',
              EX_IN_FIXED_QTY: 'order_detail_order_info_item_detail_product_detail_quantity_detail_ex_in_fixed_qty'
            }
          },

          // 注文明細_単品値引き
          DISCOUNT_DETAIL: 'order_detail_order_info_item_detail_discount_detail',
          DiscountDetail: {
            PROMOTION_ID: 'order_detail_order_info_item_detail_discount_detail_promotion_id',
            CAMPAIGN_ID: 'order_detail_order_info_item_detail_discount_detail_campaign_id',
            COUPON_ID: 'order_detail_order_info_item_detail_discount_detail_coupon_id',
            REASON_CODE: 'order_detail_order_info_item_detail_discount_detail_reason_code',
            QUANTITY: 'order_detail_order_info_item_detail_discount_detail_quantity',
            GROSS_PRICE: 'order_detail_order_info_item_detail_discount_detail_gross_price'
          },
          // 注文明細_手数料
          FEE_DETAIL: 'order_detail_order_info_item_detail_fee_detail',
          FeeDetail: {
            LINE_ITEM_TEXT: 'order_detail_order_info_item_detail_fee_detail_line_item_text',
            GROSS_PRICE: 'order_detail_order_info_item_detail_fee_detail_gross_price'
          }
        },
        // ポイント
        POINT: 'order_detail_order_info_point',
        point: {
          POINT: 'order_detail_order_info_point_point',
          CONSUMED_POINT: 'order_detail_order_info_point_consumedPoint'
        },
        // 小計後値引/注文合計金額
        TOTAL_DETAIL: 'order_detail_order_info_total_detail',
        TotalDetail: {
          // 操作
          MERCHANDISE_PRICE_ADJUSTMENTS: 'order_detail_order_info_total_detail_edit_merchandise_price_adjustments',
          POINT_PRICE_ADJUSTMENTS: 'order_detail_order_info_total_detail_edit_point_price_adjustments',

          // 注文明細_小計後値引
          ADJUSTMENTS_DETAIL: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail',
          AdjustmentsDetail: {
            PROMOTION_ID: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail_promotion_id',
            CAMPAIGN_ID: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail_campaign_id',
            COUPON_ID: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail_coupon_id',
            REASON_CODE: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail_reason_code',
            GROSS_PRICE: 'order_detail_order_info_total_detail_merchandise_price_adjustments_detail_gross_price'
          }
        },
        // 支払種別内訳
        PAYMENT_TYPE_BREAKDOWN: 'order_detail_order_info_payment_type_breakdown',
        PaymentTypeBreakdown: {
          ADD_PAYMENT_METHOD: 'order_detail_order_info_payment_type_breakdown_add_payment',
          PAYMENT_LINKAGE: 'order_detail_order_info_payment_type_breakdown_payment_linkage',
          STATUS: 'order_detail_order_info_payment_type_breakdown_status',
          IS_RESERVED: 'order_detail_order_info_payment_type_breakdown_is_reserved',
          PAYMENT_METHOD: 'order_detail_order_info_payment_type_breakdown_payment_method',
          TRANSACTION_ID: 'order_detail_order_info_payment_type_breakdown_transaction_id',
          ORDER_TOTAL_GROSS_PRICE: 'order_detail_order_info_payment_type_breakdown_order_total_gross_price',
          DETAIL: 'order_detail_order_info_payment_type_detail',
          Detail: {
            PAYMENT_METHOD_NAME: 'order_detail_order_info_payment_type_detail_payment_method_name',
            AMOUNT: 'order_detail_order_info_payment_type_detail_amount',
            TRANSACTION_ID_1: 'order_detail_order_info_payment_type_detail_transaction_id_1',
            TRANSACTION_ID_2: 'order_detail_order_info_payment_type_detail_transaction_id_2',
            TRANSACTION_ID_3: 'order_detail_order_info_payment_type_detail_transaction_id_3',
            IS_PAID: 'order_detail_order_info_payment_type_detail_is_paid',
            PAID_AT: 'order_detail_order_info_payment_type_detail_paid_at',
            IS_PROCESSED: 'order_detail_order_info_payment_type_detail_is_processed',
            EDITABLE_TYPE: 'order_detail_order_info_payment_type_detail_editable_type'
          }
        }
      },

      // メモ'
      NOTE: 'order_detail_note',
      Note: {
        NEW: 'order_detail_note_new',
        EDIT: 'order_detail_note_edit',
        DELETE: 'order_detail_note_delete',
        CREATED_AT: 'order_detail_note_created_at',
        UPDATE_AT: 'order_detail_note_update_at',
        SUBJECT: 'order_detail_note_subject'
      },

      // 更新履歴
      LOG: 'order_detail_log',
      Log: {
        CREATED_AT: 'order_detail_log_created_at',
        TYPE: 'order_detail_log_type',
        DETAIL: 'order_detail_log_detail',
        CREATED_BY: 'order_detail_log_created_by'
      },

      // 指図・出荷
      EXPORT_AND_SHIPPED: 'order_detail_export_and_shipped',
      ExportAndShipped: {
        EXPORT_LIST: 'order_detail_export_and_shipped_export_list',
        ExportList: {
          CREATED_AT: 'order_detail_export_and_shipped_export_list_created_at',
          STATUS: 'order_detail_export_and_shipped_export_list_status',
          LIST_ID: 'order_detail_export_and_shipped_export_list_id',
          EXPORTED_AT: 'order_detail_export_and_shipped_export_list_exported_at',
          QUANTITY: 'order_detail_export_and_shipped_export_list_quantity',

          DETAIL: 'order_detail_export_and_shipped_export_list_detail',
          Detail: {
            EXPORT_SHIPPED_NO: 'order_detail_export_and_shipped_export_list_detail_order_export_shipped_number',
            EXPORTABLE_AT: 'order_detail_export_and_shipped_export_list_detail_exportable_at',
            CLOSED_AT: 'order_detail_export_and_shipped_export_list_detail_closed_at',
            EXPORTED_AT: 'order_detail_export_and_shipped_export_list_detail_exported_at',
            PRODUCT_ID: 'order_detail_export_and_shipped_export_list_detail_product_id',
            QUANTITY: 'order_detail_export_and_shipped_export_list_detail_quantity',
            EXPORT_TYPE: 'order_detail_export_and_shipped_export_list_detail_export_type'
          }
        },
        SHIPPED_LIST: 'order_detail_export_and_shipped_shipped_list',
        ShippedList: {
          SLIP_DATETIME: 'order_detail_export_and_shipped_shipped_list_slip_datetime',
          ORDER_EXPORT_ID: 'order_detail_export_and_shipped_shipped_list_order_export_id',
          SLIP_TYPE: 'order_detail_export_and_shipped_shipped_list_slip_type',
          SLIP_NUMBER: 'order_detail_export_and_shipped_shipped_list_slip_number',
          CORRECT_TYPE: 'order_detail_export_and_shipped_shipped_list_correct_type',
          TRACKING_NUMBER: 'order_detail_export_and_shipped_shipped_list_tracking_number',
          QUANTITY: 'order_detail_export_and_shipped_shipped_list_quantity',
          DETAIL: 'order_detail_export_and_shipped_shipped_list_detail',
          Detail: {
            EXPORT_SHIPPED_NO: 'order_detail_export_and_shipped_shipped_list_detail_order_export_shipped_number',
            SLIP_TYPE: 'order_detail_export_and_shipped_shipped_list_detail_slip_type',
            SLIP_TYPE_DETAIL: 'order_detail_export_and_shipped_shipped_list_detail_slip_type_detail',
            SLIP_NO: 'order_detail_export_and_shipped_shipped_list_detail_slip_number',
            SLIP_NO_SUFFIX: 'order_detail_export_and_shipped_shipped_list_detail_slip_number_suffix',
            SLIP_DATETIME: 'order_detail_export_and_shipped_shipped_list_detail_slip_datetime',
            CORRECT_TYPE: 'order_detail_export_and_shipped_shipped_list_detail_correct_type',
            TRACKING_NO: 'order_detail_export_and_shipped_shipped_list_detail_tracking_number',
            PRODUCT_ID: 'order_detail_export_and_shipped_shipped_list_detail_product_id',
            REQUEST_QTY: 'order_detail_export_and_shipped_shipped_list_detail_request_quantity',
            QUANTITY: 'order_detail_export_and_shipped_shipped_list_detail_quantity',
            REASON_CODE: 'order_detail_export_and_shipped_shipped_list_detail_reason_code'
          }
        }
      },

      // 支払処理結果
      PAYMENT_SET: 'order_detail_payment_set',
      PaymentSet: {
        // 操作
        CANCEL: 'order_detail_payment_set_cancel',
        RETRY: 'order_detail_payment_set_retry',
        ERROR_IGNORE: 'order_detail_payment_set_error_ignore',
        CHANGE_PAYMENT: 'order_detail_payment_set_change_payment',
        REGISTER_REFUND_DATE: 'order_detail_payment_set_register_refund_date',

        // 項目
        CREATED_AT: 'order_detail_payment_set_created_at',
        PAYMENT_METHOD: 'order_detail_payment_set_payment_method',
        PROCESS_TYPE: 'order_detail_payment_set_process_type',
        STATUS: 'order_detail_payment_set_status',
        PROCESSED_AT: 'order_detail_payment_set_processed_at',
        DETAIL: 'order_detail_payment_set_detail',
        Detail: {
          PAYMENT_METHOD_NAME: 'order_detail_payment_set_detail_payment_method_name',
          AMOUNT: 'order_detail_payment_set_detail_amount',
          TRANSACTION_ID_1: 'order_detail_payment_set_detail_transaction_id_1',
          TRANSACTION_ID_2: 'order_detail_payment_set_detail_transaction_id_2',
          TRANSACTION_ID_3: 'order_detail_payment_set_detail_transaction_id_3',
          PROCESS_TYPE: 'order_detail_payment_set_detail_process_type',
          STATUS: 'order_detail_payment_set_detail_status',
          IS_RESERVED: 'order_detail_payment_set_detail_is_reserved',
          CANCELLABLE: 'order_detail_payment_set_detail_is_cancellable',
          PROCESSES_AT: 'order_detail_payment_set_detail_processes_at',
          PROCESSED_AT: 'order_detail_payment_set_detail_processed_at',
          REQUESTED_AT: 'order_detail_payment_set_detail_requested_at',
          RESPONSED_AT: 'order_detail_payment_set_detail_responsed_at',
          RESPONSE_CODE: 'order_detail_payment_set_detail_response_code',
          ERROR_REASON: 'order_detail_payment_set_detail_error_reason',
          ATTRIBUTE: 'order_detail_payment_set_detail_attribute'
        }
      },
      // メール送信履歴
      MAIL: 'order_detail_mail',
      Mail: {
        TEMPLATE_NAME: 'order_detail_mail_template_name',
        SCHEDULED_SEND_AT: 'order_detail_mail_scheduled_send_at',
        SEND_AT: 'order_detail_mail_sent_at',
        CREATED_AT: 'order_detail_mail_created_at'
      },
      // API実行履歴
      COOPERATE: 'order_detail_cooperate',
      Cooperate: {
        API_NAME: 'order_detail_cooperate_api_name',
        REQUESTED_AT: 'order_detail_cooperate_requested_at',
        RESPONSED_AT: 'order_detail_cooperate_responsed_at',
        ERROR_REASON: 'order_detail_cooperate_error_reason',
        CREATED_AT: 'order_detail_cooperate_created_at'
      }

    }
  },
  ACCOUNT: 'menu_account',
  Account: {
    Account: {
      LIST: 'account_list',
      List: {
        ACCOUNT: 'account_list_account',
        SITE_ROLE: 'account_list_site_role',
        PERMISSION_ROLE: 'account_list_permission_role'
      },
      DETAIL: 'account_detail',
      Detail: {
        // 操作権限
        NEW: 'account_detail_new',
        EDIT: 'account_detail_edit',
        DELETE: 'account_detail_delete',

        // 各項目の権限
        TYPE: 'account_detail_type',
        TIMEZONE: 'account_detail_timezone',
        PERMISSION_ROLE_UUID: 'account_detail_auth_role_uuid',
        SITE_ROLE_UUID: 'account_detail_site_role_uuid',
        VALID_IPS: 'account_detail_valid_ips',
        EXPIRES: 'account_detail_expires',
        REFRESH_EXPIRES: 'account_detail_refresh_expires',
        API_KEY: 'account_detail_api_key',
        ALLOW_COOKIE: 'account_detail_allow_cookie',
        COOKIE_IP: 'account_detail_cookie_ip',
        IS_NOTICE: 'account_detail_is_notice',
        IS_CONSOLE: 'account_detail_is_console'
      }
    },
    SiteRole: {
      LIST: 'site_role_list',
      List: {
        NAME: 'site_role_list_name',
        TYPE: 'site_role_list_type'
      },

      DETAIL: 'site_role_detail',
      Detail: {
        // 操作権限
        NEW: 'site_role_detail_new',
        EDIT: 'site_role_detail_edit',
        DELETE: 'site_role_detail_delete'
      }
    },
    PermissionRole: {
      LIST: 'permission_role_list',
      List: {
        NAME: 'permission_role_list_name',
        TYPE: 'permission_role_list_type'
      },

      DETAIL: 'permission_role_detail',
      Detail: {
        // 操作権限
        NEW: 'permission_role_detail_new',
        EDIT: 'permission_role_detail_edit',
        DELETE: 'permission_role_detail_delete'
      }
    }
  },
  // ファイル入出力
  FILEIO: 'menu_upload_download',
  FileIo: {
    DOWNLOAD: 'download',
    UPLOAD: 'upload'
  },
  // 顧客
  CUSTOMER: 'menu_customer',
  Customer: {
    LIST: 'customer_list',
    List: {
      CUSTOMER_GROUP: 'customer_list_customer_group',
      CUSTOMER_MAIN_NUMBER: 'customer_list_customer_main_number',
      CUSTOMER_NUMBERS: 'customer_list_customer_numbers',
      NAME: 'customer_list_name',
      MAILADDRESS: 'customer_list_mailaddress'
    },
    DETAIL: 'customer_detail',
    Detail: {
      EDIT: 'customer_detail_edit',
      REGISTER_POINT: 'customer_detail_register_point',

      // 基本情報タブ
      BASIC_INFO: 'customer_detail_basic_info',
      BasicInfo: {
        // 基本情報パネル
        BASIC_INFO: 'customer_detail_basic_info_basic_info',
        BasicInfo: {
          CUSTOMER_GROUP: 'customer_detail_basic_info_basic_info_customer_group',
          CUSTOMER_NUMBERS: 'customer_detail_basic_info_basic_info_customer_numbers',
          NAME: 'customer_detail_basic_info_basic_info_name',
          MAILADDRESS: 'customer_detail_basic_info_basic_info_mailaddress',
          CUSTOMER_RANK: 'customer_detail_basic_info_basic_info_customer_rank',
          COMPANY_NAME: 'customer_detail_basic_info_basic_info_company_name',
          JOB_TITLE: 'customer_detail_basic_info_basic_info_job_title',
          PHONE: 'customer_detail_basic_info_basic_info_phone',
          BIRTH_DAY: 'customer_detail_basic_info_basic_info_birth_day',
          GENDER: 'customer_detail_basic_info_basic_info_gender',
          REGISTERER_AT: 'customer_detail_basic_info_basic_info_registered_at'
        },
        // ポイントパネル
        POINT: 'customer_detail_basic_info_point',
        Point: {
          NORMAL_POINT: 'customer_detail_basic_info_point_nomarl_point',
          LIMITED_POINT: 'customer_detail_basic_info_point_limited_point',
          EXPIRE: 'customer_detail_basic_info_point_expire',
          LIMITED_EXPIRE: 'customer_detail_basic_info_point_limited_expire'
        }
      },
      // 購入履歴タブ
      PURCHASE_HISTORY: 'customer_detail_purchase_history',
      PurchaseHistory: {
        ORDER_NUMBER: 'customer_detail_purchase_history_order_number',
        SHIPMENT_ID: 'customer_detail_purchase_history_shipment_id',
        SITE: 'customer_detail_purchase_history_site',
        ORDER_DATETIME: 'customer_detail_purchase_history_order_datetime',
        ORDERER_NAME: 'customer_detail_purchase_history_orderer_name',
        PURCHASE_AMOUNT: 'customer_detail_purchase_history_purchase_amount',
        IS_PAID: 'customer_detail_purchase_history_is_paid',
        PAYMENT_METHOD: 'customer_detail_purchase_history_payment_method',
        ORDER_STATUS: 'customer_detail_purchase_history_order_status',
        ORDER_NOTES: 'customer_detail_purchase_history_order_notes'
      },

      // ポイント履歴タブ
      POINT_HISTORY: 'customer_detail_point_history',
      PointHistory: {
        REGISTERED_AT: 'customer_detail_point_history_registered_at',
        POINT_CATEGORY: 'customer_detail_point_history_point_category',
        LIMITED_FLAG: 'customer_detail_point_history_limited_flag',
        POINT: 'customer_detail_point_history_point',
        REMAINING_POINT: 'customer_detail_point_history_remaining_point',
        EXPIRE: 'customer_detail_point_history_expire',
        REASON_CODE: 'customer_detail_point_history_reason_code',
        NOTE: 'customer_detail_point_history_note',
        MEMO: 'customer_detail_point_history_memo',
        ATTRIBUTE: 'customer_detail_point_history_attribute'
      }
    },
    POINT_HISTORY: 'point_history_list'
  },

  // 商品
  PRODUCT: 'menu_product',
  Product: {
    LIST: 'product_list',
    List: {
    },
    ORDERQUANTITY: {
      LIST: 'product_order_quantity_list',
      DOWNLOAD: 'product_order_quantity_download'
    },
    DETAIL: 'product_detail',
    Detail: {
      NEW: 'product_detail_new',
      EDIT: 'product_detail_edit',
      INVALIDATE: 'product_detail_invalidate',

      // 基本情報タブ
      BasicInfo: {
        NAME: 'product_detail_basic_info_name',
        NAME_KANA: 'product_detail_basic_info_name_kana',
        CORE_NAME: 'product_detail_basic_info_core_product_name',
        ABBREVIATION_NAME: 'product_detail_basic_info_product_name_abbreviation',
        PRODUCT_TYPE: 'product_detail_basic_info_product_type',
        PRODUCT_CATEGORY: 'product_detail_basic_info_product_category',
        MAKER_PRODUCT_CODE: 'product_detail_basic_info_maker_product_code',
        PRODUCT_YEAR: 'product_detail_basic_info_product_year',
        BRAND: 'product_detail_basic_info_brand',
        SUB_BRAND: 'product_detail_basic_info_sub_brand',
        LABEL: 'product_detail_basic_info_label',
        SUB_LABEL: 'product_detail_basic_info_sub_label',
        MAIN_CATEGORY: 'product_detail_basic_info_main_category',
        CATEGORY: 'product_detail_basic_info_category',
        GENDER: 'product_detail_basic_info_gender',
        SALES_PERIOD_FROM: 'product_detail_basic_info_sales_period_from',
        SALES_PERIOD_TO: 'product_detail_basic_info_sales_period_to',
        IS_ONLINE: 'product_detail_basic_info_is_online',
        ONLINE_DATETIME: 'product_detail_basic_info_online_datetime',
        OFFLINE_DATETIME: 'product_detail_basic_info_offline_datetime',
        IS_BUYABLE_ONLY: 'product_detail_basic_info_is_buyable_only',
        IS_SHIPMENT: 'product_detail_basic_info_is_shipment',
        IS_INVENTORY_CONTROL: 'product_detail_basic_info_is_inventory_control',
        IS_SEARCHABLE: 'product_detail_basic_info_is_searchable',
        IS_SEARCHABLE_IF_UNAVAILABLE:
            'product_detail_basic_info_is_searchable_if_unavailable',
        ATTRIBUTE: 'product_detail_basic_info_attribute'
      },

      // 商品説明タブ
      INTRODUCTION_INFO: 'product_detail_introduction',
      IntroductionInfo: {
        DESCRIPTION: 'product_detail_introduction_description',
        DETAIL: 'product_detail_introduction_detail',
        CATCH_PHRASE: 'product_detail_introduction_catchphrase',
        MEDIA_COVERAGE: 'product_detail_introduction_media_coverage',
        TAG: 'product_detail_introduction_tag',
        SEO_MEASUREMENT: 'product_detail_introduction_seo_measurement',
        APPEAL: 'product_detail_introduction_appeal',
        REMARKS: 'product_detail_introduction_remarks',
        ATTRIBUTE: 'product_detail_introduction_attribute'
      },

      // SKUタブ
      SKU: 'product_detail_sku',
      Sku: {
        SKU_CODE: 'product_detail_sku_sku_code',
        SKU_NAME: 'product_detail_sku_sku_name',
        NAME_KANA: 'product_detail_sku_sku_name_kana',
        ABBREVIATION_NAME: 'product_detail_sku_sku_name_abbreviation',
        JAN_CODE: 'product_detail_sku_jan_code',
        SKU_TYPE: 'product_detail_sku_sku_type',
        MAKER_SKU_CODE: 'product_detail_sku_maker_sku_code',
        EAN_CODE: 'product_detail_sku_ean_code',
        MIN_ORDER_QUANTITY: 'product_detail_sku_min_order_quantity',
        MAX_ORDER_QUANTITY: 'product_detail_sku_max_order_quantity',
        MAX_ORDERABLE_QUANTITY_FOR_USER: 'product_detail_sku_max_orderable_quantity_for_user',
        SUGGESTED_RETAIL_PRICE_EX_TAX: 'product_detail_sku_suggested_retail_price_ex_tax',
        SUGGESTED_RETAIL_PRICE_IN_TAX: 'product_detail_sku_suggested_retail_price_in_tax',
        COST_EX_TAX: 'product_detail_sku_cost_ex_tax',
        NET_PRICE_EX_TAX: 'product_detail_sku_net_price_ex_tax',
        NET_PRICE_IN_TAX: 'product_detail_sku_net_price_in_tax',
        RELEASE_DATETIME: 'product_detail_sku_release_datetime',
        PREPARING_SHIPMENT_STARTED_AT: 'product_detail_sku_preparing_shipment_started_at',
        DISPLAY_ORDER: 'product_detail_sku_display_order',
        SALES_PERIOD_FROM: 'product_detail_sku_sales_period_from',
        SALES_PERIOD_TO: 'product_detail_sku_sales_period_to',
        IS_ONLINE: 'product_detail_sku_is_online',
        ONLINE_DATETIME: 'product_detail_sku_online_datetime',
        OFFLINE_DATETIME: 'product_detail_sku_offline_datetime',
        DESCRIPTION: 'product_detail_sku_description',
        DETAIL: 'product_detail_sku_detail',
        IS_BUYABLE_ONLY: 'product_detail_sku_is_buyable_only',
        IS_SHIPMENT: 'product_detail_sku_is_shipment',
        IS_INVENTORY_CONTROL: 'product_detail_sku_is_inventory_control',
        IS_SEARCHABLE: 'product_detail_sku_is_searchable',
        IS_SEARCHABLE_IF_UNAVAILABLE: 'product_detail_sku_is_searchable_if_unavailable',
        ATTRIBUTE: 'product_detail_sku_attribute'
      },

      // バンドル/セットタブ
      BUNDLE_SET: 'product_detail_bundle_set',
      BundleSet: {
        SKU_CODE: 'product_detail_bundle_set_sku_code',
        NAME: 'product_detail_bundle_set_sku_name',
        NAME_KANA: 'product_detail_bundle_set_sku_name_kana',
        ABBREVIATION_NAME: 'product_detail_bundle_set_sku_name_abbreviation',
        JAN_CODE: 'product_detail_bundle_set_jan_code',
        MAKER_SKU_CODE: 'product_detail_bundle_set_maker_sku_code',
        EAN_CODE: 'product_detail_bundle_set_ean_code',
        SUGGESTED_RETAIL_PRICE_EX_TAX: 'product_detail_bundle_set_suggested_retail_price_ex_tax',
        SUGGESTED_RETAIL_PRICE_IN_TAX: 'product_detail_bundle_set_suggested_retail_price_in_tax',
        COST_EX_TAX: 'product_detail_bundle_set_cost_ex_tax',
        NET_PRICE_EX_TAX: 'product_detail_bundle_set_net_price_ex_tax',
        NET_PRICE_IN_TAX: 'product_detail_bundle_set_net_price_in_tax',
        RELEASE_DATETIME: 'product_detail_bundle_set_release_datetime',
        PREPARING_SHIPMENT_STARTED_AT: 'product_detail_bundle_set_preparing_shipment_started_at',
        SALES_PERIOD_FROM: 'product_detail_bundle_set_sales_period_from',
        SALES_PERIOD_TO: 'product_detail_bundle_set_sales_period_to',
        IS_ONLINE: 'product_detail_bundle_set_is_online',
        ONLINE_DATETIME: 'product_detail_bundle_set_online_datetime',
        OFFLINE_DATETIME: 'product_detail_bundle_set_offline_datetime',
        DESCRIPTION: 'product_detail_bundle_set_introduction',
        DETAIL: 'product_detail_bundle_set_detail',
        IS_SEARCHABLE: 'product_detail_bundle_set_is_searchable',
        IS_SEARCHABLE_IF_UNAVAILABLE:
            'product_detail_bundle_set_is_searchable_if_unavailable',
        ATTRIBUTE: 'product_detail_bundle_set_attribute'
      },
      // 画像タブ
      IMAGE: 'product_detail_image',
      Image: {
        DESCRIPTION: 'product_detail_image_description',
        TYPE: 'product_detail_image_type',
        ATTRIBUTE: 'product_detail_image_attribute'
      }
    }
  },
  STOCK: 'menu_stock',
  Stock: {
    EcStock: {
      LIST: 'stock_list',
      List: {
        STOCK_MOVE: 'd_ec_stock_distr_move',
        AMOUNT: 'd_ec_stock_distr_amount_edit',
        STANDARD: 'd_ec_stock_standard_edit',
        REGSTERED: 'd_ec_stock_regstered_edit'
      }
    },
    Alert: {
      LIST: 'stock_alert_list',
      DETAIL: 'stock_alert_detail',
      Detail: {
        // 操作権限
        NEW: 'stock_alert_detail_new',
        EDIT: 'stock_alert_detail_edit',
        DELETE: 'stock_alert_detail_delete'
      }
    }
  },
  Master: {
    Color: {
      LIST: 'master_color_list',
      EDIT: 'master_color_edit'
    },
    ColorGroup: {
      LIST: 'master_color_group_list',
      EDIT: 'master_color_group_edit'
    },
    Size: {
      LIST: 'master_size_list',
      EDIT: 'master_size_edit'
    },
    SizeGroup: {
      LIST: 'master_size_group_list',
      EDIT: 'master_size_group_edit'
    },
    Component: {
      LIST: 'master_component_list',
      EDIT: 'master_component_list_edit'
    }
  },
  SHIP: 'menu_ship',
  Ship: {
    LogisticsCalendar: {
      LIST: 'master_ship_holiday_list',
      EDIT: 'master_ship_holiday_edit'
    }
  },
  SETTINGS: 'menu_settings',
  MailTemplate: {
    LIST: 'mail_template_list',
    List: {
      SITE: 'mail_template_list_site',
      TYPE: 'mail_template_list_type',
      NAME: 'mail_template_list_name',
      FROM: 'mail_template_list_from',
      FROM_MINE: 'mail_template_list_from_mine',
      TO: 'mail_template_list_to',
      CC: 'mail_template_list_cc',
      BCC: 'mail_template_list_bcc',
      REPLY_TO: 'mail_template_list_reply_to',
      SUBJECT: 'mail_template_list_subject',
      TEXT: 'mail_template_list_text',
      HTML: 'mail_template_list_html',
      NEW: 'mail_template_list_new',
      EDIT: 'mail_template_list_edit',
      DELETE: 'mail_template_list_delete'
    }
  }
})



// WEBPACK FOOTER //
// ./src/define.js